/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".dummy_d5b81683{background:blue}\n"}]);
export const dummy = "dummy_d5b81683";